export interface FinalCountdown {
  enabled: boolean;
  
  // Configurações Básicas
  countdownSeconds: number; // 5-60
  redirectUrl: string;
  linkOpenMode: 'sameTab' | 'newTab';
  
  // Textos Personalizados
  title: string; // "Oferta Especial Liberada!"
  description: string; // "Você será redirecionado em {timer} segundos..."
  
  // Botão "Ir Agora"
  showButton: boolean;
  buttonText: string; // "Ir Agora"
  buttonAction: 'redirect' | 'newTab';
  
  // Modo Forçado
  forcedMode: boolean;
  
  // BLOCO A - FUNDO DA TELA
  overlayColor: string;
  overlayOpacity: number;
  
  // BLOCO B - CARD PRINCIPAL
  cardSize: 'small' | 'medium' | 'large';
  cardColor: string;
  cardOpacity: number;
  cardBorderRadius: number;
  fullScreen: boolean;
  
  // BLOCO C - CÍRCULO DA CONTAGEM
  circleColor: string;
  circleTextColor: string;
  circleSize: 'small' | 'medium' | 'large';
  
  // BLOCO D - TEXTOS
  titleColor: string;
  descriptionColor: string;
  
  // BLOCO E - BOTÃO
  buttonColor: string;
  buttonTextColor: string;
  buttonBorderRadius: number;
  
  // Animação
  animation: 'fade' | 'fadeZoom' | 'slideUp';
  
  // Preset de estilo
  stylePreset: 'host' | 'minimal' | 'urgencia' | 'clean';
  
  // Ação ao finalizar
  redirectMode: 'redirect' | 'warning';
}

export const defaultFinalCountdown: FinalCountdown = {
  enabled: false,
  countdownSeconds: 10,
  redirectUrl: '',
  linkOpenMode: 'sameTab',
  title: 'Oferta Especial Liberada!',
  description: 'Você será redirecionado em {timer} segundos...',
  showButton: true,
  buttonText: 'Ir Agora',
  buttonAction: 'redirect',
  forcedMode: false,
  
  // BLOCO A - FUNDO DA TELA
  overlayColor: '#000000',
  overlayOpacity: 70,
  
  // BLOCO B - CARD PRINCIPAL
  cardSize: 'medium',
  cardColor: '#ffffff',
  cardOpacity: 100,
  cardBorderRadius: 12,
  fullScreen: false,
  
  // BLOCO C - CÍRCULO DA CONTAGEM
  circleColor: '#f3f4f6',
  circleTextColor: '#000000',
  circleSize: 'medium',
  
  // BLOCO D - TEXTOS
  titleColor: '#000000',
  descriptionColor: '#666666',
  
  // BLOCO E - BOTÃO
  buttonColor: '#3b82f6',
  buttonTextColor: '#ffffff',
  buttonBorderRadius: 10,
  
  // ANIMAÇÃO
  animation: 'fadeZoom',
  
  // PRESET
  stylePreset: 'host',
  
  // AÇÃO
  redirectMode: 'redirect',
};
